import Flex from './utils/Flex'
import DefaultAvatar from '../assets/images/avatar.png'

const Comment = ({ user, comment, ghost = false }) => {
	return (
		<div>
			<Flex on="sm">
				<div className="float-left sm:float-none mr-3 lg:mr-5 relative h-9 w-9 lg:h-11 lg:w-11 rounded-full flex-none overflow-hidden">
					<img
						src={ghost ? DefaultAvatar : user.thumbnail}
						alt='User profile thumbnail'
						className="w-full h-full object-cover object-center"
					/>
				</div>
				<div>
					<p className="text-base lg:text-lg">
						<span className="cursor-pointer font-bold">
							{ghost ? "@Anonymous" : user.username}
						</span>
						<span className='ml-2'>{comment}</span>
					</p>
				</div>
			</Flex>
			<Flex justify-end className="space-x-4 mt-2">
				<p className="text-base lg:text-xl text-cyan-accent">Tipped $5.00</p>
				<button className="text-base lg:text-xl text-white">Like</button>
				<button className="text-base lg:text-xl text-white">Reply</button>
				<p className="text-base lg:text-xl text-gray-400">Yesterday</p>
			</Flex>
		</div>
	)
}

export default Comment